import { z } from 'zod';

const WORKSPACE_SLUG_REGEX = /^[a-z0-9-]+$/;

export const workspaceSettingsSchema = z.object({
  name: z.string().min(2, 'Workspace name is required.'),
  slug: z
    .string()
    .min(2, 'Workspace URL is required.')
    .regex(
      WORKSPACE_SLUG_REGEX,
      'Workspace URL must use lowercase letters, numbers, and dashes only.',
    ),
  industry_id: z.string().min(1, 'Industry is required.'),
  currency_code: z.string().optional().default(''),
  logo_asset_key: z.string().optional().default(''),
});
